// src/Providers.js
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient }        from './queryClient';
import { AuthProvider }       from './modules/Base/Auth/contexts/AuthContext';
import { GeoProvider }        from './context/GeoContext';
import { SocketProvider }     from './context/SocketContext';

export function AppProviders({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GeoProvider>
          <SocketProvider>
            {children}
          </SocketProvider>
        </GeoProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
